import Vue from 'vue'
import VueRouter from 'vue-router'
import { mutations } from '@/store.js'
import { getters } from '@/store.js'
import SignIn from "../views/SignIn";
import ForgotPassword from "../views/ForgotPassword";
import ResetPassword from "../views/ResetPassword";
import PeachPaymentsCallback from "../views/PeachPaymentsCallback";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'SignIn',
    component: SignIn,
    meta: { title: 'Sign In to BetterGuest Host' }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: { title: 'Request password reset' }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: { title: 'Reset your password' }
  },
  {
    path: '/credit-card-updated',
    name: 'PeachPaymentsCallback',
    component: PeachPaymentsCallback,
    meta: { title: 'Credit Card Updated' }
  },
  {
    path: '/account',
    name: 'Account',
    component: () => import(/* webpackChunkName: "configure-workflow" */ '../views/Account.vue'),
    meta: { title: 'Account' }
  },
  {
    path: '/create-account',
    name: 'CreateAccount',
    component: () => import(/* webpackChunkName: "configure-workflow" */ '../views/CreateAccount.vue'),
    meta: { title: 'Create a new account' }
  },
  {
    path: '/list-establishments',
    name: 'ListEstablishments',
    component: () => import(/* webpackChunkName: "configure-workflow" */ '../views/ListEstablishments.vue'),
    meta: { title: 'Establishments' }
  },
  {
    path: '/whatsapp-templates',
    name: 'WhatsAppTemplates',
    component: () => import(/* webpackChunkName: "configure-workflow" */ '../views/WhatsAppTemplates.vue'),
    meta: { title: 'WhatsApp Templates' }
  },
  {
    path: '/tasks',
    name: 'TaskCalendar',
    component: () => import(/* webpackChunkName: "configure-workflow" */ '../views/TaskCalendar.vue'),
    meta: { title: 'Tasks' }
  },
  {
    path: '/tasks/from/:year/:month/:day',
    name: 'JumpToDateOnTaskCalendar',
    component: () => import(/* webpackChunkName: "configure-workflow" */ '../views/TaskCalendar.vue'),
    meta: { title: 'Tasks' }
  },
  {
    path: '/automations',
    name: 'Automations',
    // route level code-splitting
    // this generates a separate chunk (configure-forms.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "automations" */ '../views/Automations.vue'),
    meta: { title: 'Automations' }
  },
  {
    path: '/guest-chat',
    name: 'GuestChats',
    // route level code-splitting
    // this generates a separate chunk (configure-forms.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "guest-chat" */ '../views/GuestChats.vue'),
    meta: { title: 'Chat' }
  },
  {
    path: '/bookings',
    name: 'Bookings',
    // route level code-splitting
    // this generates a separate chunk (configure-forms.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "forms" */ '../views/ListBookings.vue'),
    meta: { title: 'Bookings' }
  },
  {
    path: '/forms',
    name: 'FormsSent',
    // route level code-splitting
    // this generates a separate chunk (configure-forms.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "forms" */ '../views/ListForms.vue'),
    meta: { title: 'Forms' }
  },
  {
    path: '/forms/:reference',
    name: 'ViewForm',
    // route level code-splitting
    // this generates a separate chunk (configure-forms.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "view-form" */ '../views/ViewForm.vue'),
    meta: { title: 'View Form' }
  },
  {
    path: '/form-templates/:reference',
    name: 'EditFormTemplate',
    // route level code-splitting
    // this generates a separate chunk (configure-forms.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "form-templates" */ '../views/EditFormTemplate.vue'),
    meta: { title: 'Edit Form' }
  },
  {
    path: '/email-templates/:reference',
    name: 'EditEmailTemplate',
    // route level code-splitting
    // this generates a separate chunk (configure-forms.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "email-templates" */ '../views/EditEmailTemplate.vue'),
    meta: { title: 'Edit Email' }
  },
  {
    path: '/email-config/header-signature',
    name: 'EditEmailHeaderSignature',
    // route level code-splitting
    // this generates a separate chunk (configure-forms.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "email-templates/header-signature" */ '../views/EditEmailHeaderSignature.vue'),
    meta: { title: 'Edit Header & Signature' }
  },
  {
    path: '/sms-templates/:reference',
    name: 'EditSMSTemplate',
    // route level code-splitting
    // this generates a separate chunk (configure-forms.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "sms-templates" */ '../views/EditSMSTemplate.vue'),
    meta: { title: 'Edit SMS' }
  },
  {
    path: '/webhooks/:reference',
    name: 'EditWebhook',
    // route level code-splitting
    // this generates a separate chunk (configure-forms.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "webhooks" */ '../views/EditWebhook.vue'),
    meta: { title: 'Edit Webhook' }
  },
  {
    path: '/automations/:reference/whatsapp-templates',
    name: 'SelectWhatsAppTemplate',
    // route level code-splitting
    // this generates a separate chunk (configure-forms.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "whatsapp-templates" */ '../views/SelectWhatsAppTemplate.vue'),
    meta: { title: 'Edit SMS' }
  },
  // ignore these paths
  {
    path: '/guide'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  console.log(to)
  if (to.name !== 'SignIn' &&
      to.name !== 'CreateAccount' &&
      to.name !== 'ForgotPassword' &&
      to.name !== 'ResetPassword' &&
      to.name !== 'PeachPaymentsCallback' &&
      (!getters.isAuthenticated() || !getters.isOnboardingComplete())) {
    console.log("Checking if authenticated: " + getters.isAuthenticated())
    console.log("NOT Authenticated... heading to Sign In page")
    mutations.signOut()
    next({name: 'SignIn'})
  } else {
    console.log("Signing in, creating account, or Authenticated...")
    next()
  }
})

const DEFAULT_TITLE = 'BetterGuest';
router.afterEach((to) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    mutations.hideNav()
    const title = to.meta.title || DEFAULT_TITLE
    document.title = title
    mutations.setTitle(title)
  })
})

export default router
